import script from "./FormularioComponente.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormularioComponente.vue?vue&type=script&lang=ts&setup=true"

import "./FormularioComponente.vue?vue&type=style&index=0&id=18690856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18690856"]])

export default __exports__